module.exports = __webpack_public_path__ + "img/PROCESO-DE.7a58fd45.png";